import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { videoIcon } from '../../../asset-images';
import { useGridDecorativeLabelStyle } from '../styles/tiles-grid-cell-decorative-label';

const CellDecorativeLabel = ({
  text,
  icon: Icon,
  secondaryText,
  additionaIconName,
  additionalText,
  customClass,
}) => {
  const classes = useGridDecorativeLabelStyle();

  return (
    <div className={classnames('cell-decorative-label-container', classes.tilesGridCellDecorativeLabel, customClass.cellLabel || classes.cellLabelDisplay)}>
      {
        (text || Icon) && (
          <div className={classnames('label-icon-and-text', customClass.iconTextWrapper)}>
            {Icon && <Icon className="label-icon" />}
            {text && <div className="label-text">{text}</div>}
          </div>
        )
      }
      {secondaryText && <div className="label-secondary-text">{secondaryText}</div>}
      {
        additionaIconName && (
          <div className="additional-icon-content">
            <img src={videoIcon} className="additional-icon" alt="" />
          </div>
        )
      }
      {
        additionalText && (
          <div className="label-additional-text">
            <div className="label-additional-content" aria-label={additionalText} role="presentation">{additionalText}</div>
          </div>
        )
      }
    </div>
  );
};

CellDecorativeLabel.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.elementType,
  additionaIconName: PropTypes.string,
  secondaryText: PropTypes.string,
  additionalText: PropTypes.string,
  customClass: PropTypes.shape({
    cellLabel: PropTypes.string,
    iconTextWrapper: PropTypes.string,
  }),
};

CellDecorativeLabel.defaultProps = {
  text: null,
  icon: null,
  secondaryText: '',
  additionalText: null,
  additionaIconName: null,
  customClass: {},
};

export const TilesGridCellDecorativeLabel = CellDecorativeLabel;
